import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';
import useEmployeeSkillRadarData from './useEmployeeSkillRadarData';
import ChartGlassPanel from '../../components/ChartGlassPanel';

export default function EmployeeSkillRadarChart() {
  const data = useEmployeeSkillRadarData();
  return (
    <ChartGlassPanel>
        <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={data} outerRadius={90}>
            <PolarGrid />
            <PolarAngleAxis dataKey="skill" />
            <PolarRadiusAxis angle={30} domain={[0, 10]} tickCount={6} />
            <Radar name="Skill Level" dataKey="level" stroke="#2563eb" fill="#38bdf8" fillOpacity={0.5} />
            <Tooltip />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </ChartGlassPanel>
  );
}
